/**
 * Created by emanuele on 31/01/2017.
 */
import React from 'react';
import PropTypes from 'prop-types';
const LoadingFrame = ({ visible, testo, dim='large' }) => (

    visible ?

        <div className="ui">
            <div className="ui active inverted dimmer">
                <div className={"ui " + dim + " text loader"}>{testo}</div>
            </div>
        </div>

:

     null
);

LoadingFrame.PropTypes = {
    visible: PropTypes.bool,
    testo: PropTypes.string,
    dim: PropTypes.string,
}

LoadingFrame.defaultProps = {
    testo: 'Caricamento dati in corso...',
    dim: 'large'
};

export default LoadingFrame;


/** WEBPACK FOOTER **
 ** ./src/components/LoadingFrame.jsx
 **/